import React, { useState } from 'react';
import QuestionDropdown from 'apps/admin/pages/questions/question-dropdown';
import * as JourneyMapForm from 'apps/admin/styles/components/styled-journeymap-form';
import { func, object, number } from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';

const StepQuestionForm = ({ onRemove, onAdd, questions }) => {
  const [selectedQuesiton, updateSelectedQuestion] = useState(null);

  const mapQuestions = ({ id, question }) => (
    <JourneyMapForm.StyleQuestionRow key={id}>
      <p> {question.internal_title} </p>
      <a href="javascript:void(0)" disabled={null} onClick={() => onRemove(id)}>
        Remove
      </a>
    </JourneyMapForm.StyleQuestionRow>
  );

  mapQuestions.propTypes = {
    id: number,
    question: object,
  };

  const updateQuestion = (e) => {
    const kiddies = Array.prototype.slice.call(e.target.children);
    const question = kiddies.find((c) => c.value == e.target.value);

    updateSelectedQuestion({
      question: {
        id: Number(question.value),
        internal_title: question.text,
      },
    });
  };

  return (
    <JourneyMapForm.StyledUPSQuestions>
      <h4>UPS Questions</h4>
      {questions.map(mapQuestions)}
      <JourneyMapForm.StyledUSPLabel>
        <QuestionDropdown
          name="selected_question"
          set="user_profile_steps"
          value={resolve(selectedQuesiton, 'question/id', '')}
          onChange={updateQuestion}
        />
        <button
          disabled={!resolve(selectedQuesiton, 'question/id', '')}
          onClick={(e) => onAdd(e, selectedQuesiton)}
        >
          Add
        </button>
      </JourneyMapForm.StyledUSPLabel>
    </JourneyMapForm.StyledUPSQuestions>
  );
};

StepQuestionForm.propTypes = {
  onAdd: func,
  onRemove: func,
  questions: object,
};

export default StepQuestionForm;
